import React, { useCallback, useEffect, useState } from 'react';

type Req=(path:string,body?:any,signal?:AbortSignal)=>Promise<any>;
type Decision={id:string;action:string;state:string;reasons:string[];stake:number;proposed:number;
  type:string;as_of:string;market_id?:string;selection_id?:number};
type Info={version:string;monitor:boolean;mode:string;cash_enabled:boolean;state:string;
  checked_at:string|null;latest_source_at:string|null;source:string;worker_error:string|null;
  paper_today?:{n:number;pnl:number;roi:number|null};owner_win_stake:number|null;
  baseline:{singles:number;multis:number};totals:Record<string,number>;
  recent:Decision[];release_ready:boolean;note:string};

const money=(v:any)=>typeof v==='number'&&Number.isFinite(v)?new Intl.NumberFormat('en-AU',
  {style:'currency',currency:'AUD',maximumFractionDigits:2}).format(v):'—';
const time=(s?:string|null)=>s?new Date(s).toLocaleString('en-AU',
  {timeZone:'Australia/Sydney',day:'numeric',month:'short',hour:'numeric',minute:'2-digit'}):'—';

export default function FadyIntelligencePanel({request}:{request:Req}){
 const [info,setInfo]=useState<Info|null>(null);
 const [error,setError]=useState('');
 const [busy,setBusy]=useState(false);
 const [details,setDetails]=useState(false);
 const reload=useCallback(async()=>{
   try{const x=await request('/api/rolling/simple-bsp/fady-intelligence');
     setInfo(x);setError('');}
   catch(e:any){setError(e.message||'Fady intelligence unavailable');}
 },[request]);
 useEffect(()=>{
   void reload();const timer=window.setInterval(()=>{if(!document.hidden)void reload();},30000);
   return ()=>window.clearInterval(timer);
 },[reload]);
 const toggle=async()=>{
   if(!info||busy)return;
   if(info.monitor&&!window.confirm('Pause Mimic Fady observation? Existing decision records will be retained.'))return;
   setBusy(true);
   try{setInfo(await request('/api/rolling/simple-bsp/fady-intelligence/monitor',{monitor:!info.monitor}));setError('');}
   catch(e:any){setError(e.message||'Monitor setting failed');}
   finally{setBusy(false);}
 };
 const recent=info?.recent||[];
 const shown=details?recent:recent.slice(0,6);
 return <div className="fady-intelligence-panel" role="region" aria-label="Mimic Fady intelligence">
   <div className="fady-intelligence-head">
     <strong>Mimic Fady Intelligence</strong>
     <span className={'fady-intelligence-state fady-intelligence-'+String(info?.state||'loading').toLowerCase()}>
       {info?.state||'Connecting'}
     </span>
     <button type="button" disabled={busy||!info} onClick={toggle}>
       {busy?'Saving…':info?.monitor?'Pause monitoring':'Resume monitoring'}
     </button>
   </div>
   <p className="fady-intelligence-shadow">SHADOW ONLY — monitoring does not place live bets. Live copying cannot be armed in this release.</p>
   <div className="fady-intelligence-metrics">
     <div><small>Observed paper P/L today</small><b>{money(info?.paper_today?.pnl)}</b></div>
     <div><small>Settled Fady bets today</small><b>{info?.paper_today?.n??'—'}</b></div>
     <div><small>Shadow copy decisions</small><b>{info?.totals?.COPY||0}</b></div>
     <div><small>Shadow reductions</small><b>{info?.totals?.REDUCE||0}</b></div>
     <div><small>Shadow skips</small><b>{info?.totals?.SKIP||0}</b></div>
   </div>
   <small className="fady-intelligence-source">Source: Fady's Betbuilder paper workspace. Not verified against a connected Betfair cash account.
     Last observed input: {time(info?.latest_source_at)} · Last monitor check: {time(info?.checked_at)}.
     WIN cap: {money(info?.owner_win_stake)} · Single baseline {Math.round((info?.baseline?.singles||0)*100)}% · Multiples cash disabled.</small>
   {info?.worker_error&&<p role="alert" className="fady-intelligence-error">Monitor error: {info.worker_error}</p>}
   {error&&<p role="alert" className="fady-intelligence-error">Could not refresh: {error}</p>}
   <div className="fady-intelligence-detail-head">
     <strong>Recent shadow decisions</strong>
     <button type="button" onClick={()=>setDetails(x=>!x)} disabled={!recent.length}>{details?'Show fewer':'Show all'}</button>
   </div>
   {shown.length?
     <div className="fady-intelligence-scroll"><table>
      <thead><tr><th>Observed</th><th>Type</th><th>Fady stake</th><th>Our shadow stake</th><th>Decision</th><th>Reason</th></tr></thead>
      <tbody>{shown.map(x=><tr key={x.id}><td>{time(x.as_of)}</td><td>{x.type}</td><td>{money(x.stake)}</td>
        <td>{money(x.proposed)}</td><td><strong>{x.action}</strong></td><td>{(x.reasons||[]).join(', ').replace(/_/g,' ').toLowerCase()}</td></tr>)}</tbody>
     </table></div>:<p className="fady-intelligence-source">No eligible Fady candidates recorded yet. Monitoring will continue without generating bets.</p>}
 </div>;
}
